import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sura-pie-pagina',
  templateUrl: './pie-pagina.component.html',
  styleUrls: ['./pie-pagina.component.scss']
})
export class PiePaginaComponent {}
